module.exports = __webpack_public_path__ + "static/media/sports-weekends.e085490e.png";